// extracted by mini-css-extract-plugin
export default {"message":"styles_message__Vj0uf","message_text":"styles_message_text__6rA4J","message_icon":"styles_message_icon__5xMNx"};